const TEAM_LINK = {
  github: {
    yanbo: 'https://github.com/dreamfly281',
    yilun: 'https://github.com/yilunzhang'
  },
  linkedin: {
    yanbo: 'https://www.linkedin.com/in/yanbo-li-b478585',
    bruce: 'https://www.linkedin.com/in/zbruceli/',
    yilun: 'https://www.linkedin.com/in/yilun-zhang-/',
    allen: 'https://www.linkedin.com/in/dixonal/'
  }
};

const ADVISER_LINK = {
  diffie: 'https://en.wikipedia.org/wiki/Whitfield_Diffie',
  wolfram: 'https://en.wikipedia.org/wiki/Stephen_Wolfram'
};

const FOOTER_LINK = {
  community: {
    medium: 'https://medium.com/nknetwork',
    youtube: ' http://www.youtube.com/c/NKNORG',
    telegram: 'https://t.me/nknorg',
    twitter: 'https://twitter.com/NKN_ORG',
    reddit: 'https://www.reddit.com/r/nknblockchain',
    discord: 'https://discord.gg/hrZvrVa',
    forum: 'https://forum.nkn.org/'
  },
  resource: {
    github: 'https://github.com/nknorg',
    devlopdoc: 'https://docs.nkn.org/',
    introduction: 'https://www.nkn.org/doc/NKN_Introduction_en.pdf',
    whitepaper: 'https://www.nkn.org/doc/NKN_Whitepaper.pdf',
    logoDownload: 'https://www.nkn.org/logo/en'
  }
};

const HOME_HEADER_LINK = {
  mainnet: 'https://explorer.nkn.org/',
  testnet: 'https://explorer.nkn.org/',
  introdeck: 'https://www.nkn.org/doc/NKN_Introduction_en.pdf'
};

const PRODUCT_LINK = {
  spacecats: 'https://github.com/PlaySpaceCats/space-cats/releases',
  nknchat: 'https://explorer.nkn.org/usecase/chat_based_on_nkn',
  iot:
    'https://medium.com/iotex/iotex-nkn-expanding-the-reach-and-impact-of-blockchain-technology-a721201d306c',
  dChat: 'https://chrome.google.com/webstore/detail/d-chat/glnmkakdjcognfgonjfcklpmjiobijii',
  acc: '',
  wallet: 'https://wallet.nkn.org',
  newWallet: 'https://newkindofwallet.com/',
  testnet: 'https://explorer.nkn.org/',
  nknx_explorer: 'https://explorer.nkn.org/',
  nknx: 'https://nknx.org/',
  dashboard: 'https://github.com/thesheepman/nkn-dashboard',
  ncdn: 'https://forum.nkn.org/t/introducing-ncdn-new-kind-of-cdn/1516',
  ncdn_zh: 'https://forum.nkn.org/t/ncdn-nkn/1877',
  tuna: 'https://forum.nkn.org/t/introducing-tuna/1611',
  tuna_ZH: 'https://forum.nkn.org/t/tuna/1633',
  nsh:'https://forum.nkn.org/t/nkn-shell-nsh-a-new-kind-of-remote-shell-that-is-more-secure-and-convenient-than-ssh/1719',
  nsh_zh:'https://forum.nkn.org/t/nkn-shell-nsh-ssh/1741',
  nsh_github: 'https://github.com/nknorg/nkn-shell-daemon',
  dftp:'https://forum.nkn.org/t/nkn-d-ftp-high-throughput-file-transfer-using-nkn-client/1711',
  dftp_zh:'https://forum.nkn.org/t/nkn-d-ftp-nkn/1738',
  dftp_github:'https://github.com/nknorg/nkn-file-transfer'
};

const MINING_INTRO = {
  en: 'https://forum.nkn.org/c/testnet-mining',
  zh: 'https://forum.nkn.org/c/chinese/mining',
  other: 'https://forum.nkn.org/c/other-communities',
  guide:
    'https://www.reddit.com/r/nknblockchain/comments/a7rg2n/how_to_mine_on_testnet_and_get_rewarded_gui_cli/ ',
  setupOnDO:
    'https://medium.com/nknetwork/setting-up-a-nkn-miner-in-5-minutes-and-run-it-free-for-2-months-with-digitalocean-76bafcd82ae8 ',
  setupOnWindows:
    'https://medium.com/nknetwork/how-to-set-up-a-nkn-miner-on-windows-10-and-run-it-as-a-automatic-service-63e5b7a6b792 ',
  makeNKM:
    'https://medium.com/nknetwork/make-your-own-nkm-new-kind-of-miner-out-of-a-raspberry-pi-dbeeed6d8130 ',
  setScripts: 'https://github.com/rxper/nkm-pi '
};

const MINING_GUIDE = {
  zh:
    'https://mp.weixin.qq.com/s?__biz=MzU4MDc2NTc5OA==&mid=2247483962&amp;idx=1&amp;sn=4956afb94f6df80592ebc97c166e56dd&source=41#wechat_redirect',
  jp: 'https://link.medium.com/fxEnMfMoNR',
  jp2: 'https://link.medium.com/MOy0CiPoNR'
};

const DOWNLOAD_MINER = {
  mac: 'https://github.com/nknorg/nkn-mining/releases',
  windows: 'https://github.com/nknorg/nkn-mining/releases',
  linux: 'https://github.com/nknorg/nkn-mining/releases',
  github: 'https://github.com/nknorg/nkn/releases',
  windowsMining: 'https://forum.nkn.org/t/windows/1418',
  n1Mining: 'https://forum.nkn.org/t/n1/828',
  raspberryPiMining: 'https://forum.nkn.org/t/make-your-own-nkm-new-kind-of-miner-out-of-a-raspberry-pi/1599',
  oneClickMining: 'https://forum.nkn.org/t/1-click-nkn-node-image-updated-for-mainnet-on-3-cloud-platforms/1413'
};

const MINING_RESOURCE = {
  offical: 'https://explorer.nkn.org/ ',
  nknx: 'https://nknx.org/',
  nkndashboard: 'https://github.com/thesheepman/nkn-dashboard'
};

const DEVELOPER_RESOURCE = {
  nkncode: 'https://github.com/nknorg/nkn',
  clientcode: 'https://github.com/nknorg/nkn-client-js ',
  walletcode: 'https://github.com/nknorg/nkn-wallet-js ',
  miningcode: 'https://github.com/nknorg/nkn-mining ',
  nnet: 'https://github.com/nknorg/nnet ',
  tuna: 'https://github.com/nknorg/tuna',
  nknwiki: 'https://github.com/nknorg/nkn/wiki',
  nkndevelopdoc: 'https://docs.nkn.org',
  nkndiscord: 'https://discord.gg/hrZvrVa',
  logoDownload: 'https://www.nkn.org/logo/en',
  testnet: 'https://explorer.nkn.org/',
  explorerNknx: 'https://explorer.nkn.org/',
  nknx: 'https://nknx.org/dashboard',
  java: 'https://github.com/RealJohnSmith/nkn-java-client',
  csharp: 'https://github.com/trueinsider/nkn-client-csharp',
  exlir: 'https://github.com/termoose/nkn_client'
};

const DEVELOPER_DAPP = {
  scatsPresentation:
    'https://medium.com/@spacecats/space-cats-on-nkn-e850767f68c1',
  scatsPresentation_ZH:
    'https://forum.nkn.org/t/nkn/1601',
  scatsDownload: 'https://github.com/PlaySpaceCats/space-cats ',
  nknchat: 'http://explorer.nkn.org/usecase/chat_based_on_nkn',
  nknx: 'https://nknx.org',
  nknxgithub: ' https://github.com/nknx-org',
  nknxpm: 'https://trello.com/b/qw9los55/nknx',

  iotexInfo:
    'https://medium.com/iotex/iotex-nkn-expanding-the-reach-and-impact-of-blockchain-technology-a721201d306c',
  iotexInfo_ZH:
    'https://forum.nkn.org/t/iotex-nkn/1586',
  // dchatInfo: 'https://www.web3infra.io/docs/Web3Infra.pdf',
  dchatTryit: 'https://forum.nkn.org/t/d-chat/1036',
  dchatGithub: 'https://github.com/web3infra/dchat',
  dchatGitlab: 'https://gitlab.com/losnappas/d-chat',
  pubSubInfo: 'https://forum.nkn.org/t/nkn-system-architecture-and-product-focus/544',
  pubSubInfo_ZH: 'https://forum.nkn.org/t/nkn-pub-sub/368',
  nanopay: 'https://forum.nkn.org/t/gigameshs-questions-about-ncdn-nanopay-and-mba/1334',
  multiClient: 'https://forum.nkn.org/t/nkn-multi-client-improving-packet-reliability-and-latency/1689',
  multiClient_zh: 'https://forum.nkn.org/t/nkn/1739',
  multiClient_github: 'https://github.com/nknorg/nkn-multiclient-js',
};

const PARTNER = {
  datapace: 'https://www.datapace.io/',
  IoTeX: 'https://iotex.io/',
  portalNetwork: 'https://www.portal.network/#/',
  dxChain: 'https://dxchain.com/',
  noia: 'https://noia.network/',
  bluzelle: 'https://bluzelle.com/',
  O3: 'https://o3.network/',
  W3I: 'https://medium.com/web3infra/web3infra-alliance-launched-de32235fb4a8',
  UUU: 'https://u.network/',
  TIP: 'https://telecominfraproject.com/',
  ONF: 'https://www.opennetworking.org/',
  cryptic: 'https://crypticlabs.org/',
  googleCloud: 'https://console.cloud.google.com/marketplace/details/nkn-public/nkn-full-node',
  AWS: 'https://aws.amazon.com/marketplace/pp/B07PWJ69BF',
  DigitalOcean: 'https://marketplace.digitalocean.com/apps/nkn-full-node',
  nokia: 'https://networks.nokia.com/',
  chinaMobile: 'https://www.10086.cn/',
  netnic: 'http://www.netnic.com.cn/'
};

const NEWS = {
  advisor:
    'https://medium.com/nknetwork/founder-and-ceo-stephen-wolfram-joins-nkn-as-technical-advisor-88326bffd2a4',
  nokia:
    'https://medium.com/nknetwork/nkn-finalist-for-nokia-open-innovation-challenge-2018-4c195e730e11',
  redemption:
    'https://medium.com/nknetwork/nkn-bi-weekly-report-december-4-december-17-2018-1603baf69faa'
};

const VIDEOLINKEN = {
  web3:
    '/static/video/web3.mp4',
  nknSDK:
    '/static/video/nkn-sdk.mp4',
  mining:
    '/static/video/mining.mp4',
  nknIntro:
    '/static/video/nkn-intro.mp4',
};

const VIDEOLINKZH = {
  web3:
    '/static/video/web3.mp4',
  nknSDK:
    '/static/video/nkn-sdk.mp4',
  mining:
    '/static/video/mining_zh.mp4',
  nknIntro:
    '/static/video/nkn-intro_zh.mp4',
};

const SWIPER = {
  web3: 'https://medium.com/web3infra/web3infra-alliance-launched-de32235fb4a8',
  upbit: 'https://sg.upbit.com/exchange?code=CRIX.UPBIT.BTC-NKN',
  bittrex: 'https://international.bittrex.com/Market/Index?MarketName=BTC-NKN',
  swap: 'https://swap.nkn.org/',
  update: 'https://medium.com/nknetwork/nkn-november-2018-update-a941be22c662',
  testnet: 'https://medium.com/nknetwork'
};

export default {
  TEAM_LINK,
  FOOTER_LINK,
  ADVISER_LINK,
  HOME_HEADER_LINK,
  PRODUCT_LINK,
  MINING_INTRO,
  MINING_GUIDE,
  DOWNLOAD_MINER,
  MINING_RESOURCE,
  DEVELOPER_RESOURCE,
  DEVELOPER_DAPP,
  PARTNER,
  NEWS,
  VIDEOLINKEN,
  VIDEOLINKZH,
  SWIPER
};



// WEBPACK FOOTER //
// ./src/assets/json/url.js